import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const UserManager = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='UserManager' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16,12 C18.3736719,13.1826446 20,15.6506255 20,19 L20,23 L4,23 L4,19 C4,15.6457258 5.6310898,13.1754259 8,12 M12,13 C15.3137085,13 18,10.3137085 18,7 C18,3.6862915 15.3137085,1 12,1 C8.6862915,1 6,3.6862915 6,7 C6,10.3137085 8.6862915,13 12,13 Z M18,7 C16.5,7 15,7.3599999 13,5 C11,7.3599999 8.5,8 6,7 M7,13 L12.0249378,18.2571942 L17,13 M12,18 L12,23' />
  </StyledIcon>
);
